<script>
import useSharedData from "@/use/SharedData";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";
import useTools from "@/use/Tools";
import {useEvaluationSkillStore} from "@/stores/Evaluation/EvalautionSkill";
import {onMounted, ref} from "vue";

export default {
    setup() {
        const {$route} = useTools();
        const {getBack} = useSharedMethod();
        const {dialog, loading} = useSharedData();

        const evaluationSkill = ref({});

        const evaluationSkillStore = useEvaluationSkillStore();

        function findById(id) {
            loading.value = true;
            axios.get(`/evaluationSkills/${id}`).then((response) => {
                evaluationSkill.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function launch() {
            loading.value = true;
            axios.put(`/evaluationSkills/close/${$route.params.id}`).then((response) => {
                evaluationSkillStore.updateEvaluationSkill(response.data);
                getBack();
            }).finally(() => {
                loading.value = false;
            });
        }

        onMounted(() => findById($route.params.id));

        return {
            dialog,
            loading,
            getBack,
            launch,
            evaluationSkill
        }
    }
}
</script>

<template>
    <div>
        <v-dialog
            v-model="dialog"
            persistent
            scrollable
            max-width="600"
        >
            <v-card>
                <w-toolbar :title="`${$t('common.launch')} ${evaluationSkill.name}`" color="cyan"/>
                <v-card-text>
                    <v-container fluid>

                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <w-btn-close @press="getBack"/>
                    <w-btn
                        icon="mdi-clock-start"
                        :text="$t('common.launch')"
                        color="cyan"
                        :loading="loading"
                        @press="launch"
                    />
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<style scoped>

</style>